import React, { useState } from "react";
import PropTypes from "prop-types";

function OptionInput({ label, onChange, name, type = "text" }) {
  const [value, setValue] = useState("");

  const handleOnChange = (e) => {
    const { value } = e.target;

    setValue(value);

    onChange(value);
  };

  return (
    <div className="create-module__container--option-input">
      <input
        type={type}
        name={name}
        onChange={handleOnChange}
        value={value}
        placeholder={label}
      />
    </div>
  );
}

OptionInput.defaultProps = {
  type: "text",
};

OptionInput.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default OptionInput;
